import { createContext, useContext, useState, useEffect } from "react";

const STORAGE_KEY = "eac_print_settings";

const defaultSettings = {
  companyName: "EAC",
  showLogo: true,
  headerColor: "#4338CA"
};

const PrintSettingsContext = createContext(null);

export const PrintSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? { ...defaultSettings, ...JSON.parse(stored) } : defaultSettings;
    } catch {
      return defaultSettings;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  }, [settings]);

  const updateSettings = (newSettings) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  };

  const resetSettings = () => {
    setSettings(defaultSettings);
  };

  return (
    <PrintSettingsContext.Provider value={{ settings, updateSettings, resetSettings }}>
      {children}
    </PrintSettingsContext.Provider>
  );
};

export const usePrintSettings = () => {
  const context = useContext(PrintSettingsContext);
  if (!context) {
    throw new Error("usePrintSettings must be used within PrintSettingsProvider");
  }
  return context;
};

export default PrintSettingsContext;
